module.exports = __webpack_public_path__ + "files/78cf4cd5968a6542ec98a728abc46b85.png";